export default __webpack_public_path__ + "static/media/023-briefcase.03ba4e00.png";